import React from 'react'

const animateScroll = (from, to, duration, currentTime = 0, increment = 20) => {
  const change = to - from

  currentTime += increment

  window.scrollTo(0, easeInOutQuad(currentTime, from, change, duration))

  if (currentTime < duration) {
    setTimeout(
      animateScroll.bind(undefined, from, to, duration, currentTime),
      increment
    )
  }
}

const easeInOutQuad = (currentTime, from, change, duration) => {
  let scrollDistance

  currentTime /= duration / 2

  if (currentTime < 1) {
    scrollDistance = (change / 2) * currentTime * currentTime + from
  } else {
    currentTime--
    scrollDistance =
      (-change / 2) * (currentTime * (currentTime - 2) - 1) + from
  }

  return scrollDistance
}

const getOffsetTop = el => {
  const rect = el.getBoundingClientRect()
  const scrollTop = window.pageYOffset
  return parseInt(rect.top + scrollTop, 10)
}

class Scroll extends React.Component {
  componentDidUpdate() {
    const { selected, offsetTop, setOffsetTop, shouldScroll } = this.props

    if (!selected) return null

    const rowOffset = 14
    const scrollPosition = getOffsetTop(this.domRef) - rowOffset

    if (shouldScroll && scrollPosition && scrollPosition !== offsetTop) {
      animateScroll(window.pageYOffset, scrollPosition, 300)
      setOffsetTop(scrollPosition)
    }
  }

  render() {
    return (
      <div data-test="scrollContainer" ref={el => (this.domRef = el)}>
        {this.props.children}
      </div>
    )
  }
}

export default Scroll
